const debug = true

export default {
	warn(message) {
	    if (debug) {
	    	console.warn(message);
	    }
	},
	error(message) {
	    if (debug) {
	        console.error(message);
	    }
	},
	debug(message) {
	    if (debug) {
	    	
	    }
	}
}